const FEETS_TO_INCHES_RATIO = 12

export const calculateHeight = (ft: Maybe<number>, inch: Maybe<number>): number =>
  (ft || 0) * FEETS_TO_INCHES_RATIO + (inch || 0)
